import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import "@styles/components/footer.scss"
import CustomLink from "@components/helpers/CustomLink"

const Footer = () => {
  const browser = typeof window !== "undefined" && window
  const data = useStaticQuery(graphql`
    {
      prismicNavigationMenu(uid: { eq: "footer" }) {
        id
        data {
          body {
            ... on PrismicNavigationMenuDataBodyLevel1Link {
              id
              primary {
                link {
                  url
                  link_type
                  target
                }
                link_label
              }
              slice_type
            }
          }
        }
      }
    }
  `)

  const links = data.prismicNavigationMenu.data.body

  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="footer__top-column">
          <h2>Links</h2>
          <ul className="footer__links">
            {links.map((link, index) => {
              return (
                <li key={`footerLink-${index}`}>
                  <CustomLink
                    target={link.primary.link.target}
                    url={link.primary.link.url}
                    type={link.primary.link.link_type}
                    label={link.primary.link_label}
                  >
                    {link.primary.link_label}
                  </CustomLink>
                </li>
              )
            })}
          </ul>
        </div>
        <div className="footer__top-column">
          <h2>Follow us</h2>
          <a href="/newsletter" className="button buttonv2-primary">
            Newsletter
          </a>
          <div>
            <ul className="footer__socials">
              <li>
                <a
                  href="https://www.facebook.com/oddboxhq/"
                  className="footer__social-link"
                >
                  Facebook
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/oddboxldn/"
                  className="footer__social-link"
                >
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/oddbox/"
                  className="footer__social-link"
                >
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer__top-column">
          <h2>Get in touch</h2>
          <a
            className="button buttonv2-primary"
            href="https://support.oddbox.co.uk/hc/en-gb"
          >
            Help & Support
          </a>
        </div>
        <div className="footer__top-column center">
          <div className="footer__logos">
            <div className="footer__bwb-logo"></div>
            <div className="footer__bcorp-logo"></div>
          </div>
        </div>
      </div>
      <div className="footer__middle">
        <p>
          <Link to="/terms-and-conditions">
            TERMS &amp; CONDITIONS | PRIVACY POLICY
          </Link>
          <span>&nbsp;</span>
          <Link to="/terms-conditions-oddisgood">
            TERMS &amp; CONDITIONS | SOCIAL MEDIA
          </Link>
          <span>&nbsp;</span>
          {browser.CookieControl && (
            <button onClick={() => browser.CookieControl.open()}>
              MANAGE COOKIES
            </button>
          )}
        </p>
      </div>
      <div className="footer__bottom">
        <p>
          © {new Date().getFullYear()} Oddbox Delivery Ltd. Registered in
          England No. 9638976
        </p>
      </div>
    </footer>
  )
}

export default Footer
